import type { GridColDef } from '@mui/x-data-grid-pro'
import { retryActionTypeTitles } from 'src/constants/scheduler/constants'
import type { RetryActionType } from 'src/constants/scheduler/enums'
import type { RetryConfigTemplate } from 'src/interfaces/retryConfigTemplate'

/** The templates endpoint has no sort parameter, so every column is `sortable: false`. */
export const retryTemplateColumns: Array<GridColDef<RetryConfigTemplate>> = [
  { field: 'id', headerName: 'ID', flex: 1, sortable: false },
  {
    field: 'type',
    headerName: 'Type',
    flex: 1,
    sortable: false,
    valueGetter: (value: RetryActionType) => {
      return retryActionTypeTitles[value] ?? value
    },
  },
  { field: 'maxAttempts', headerName: 'Max attempts', width: 140, sortable: false },
  { field: 'backoffMultiplier', headerName: 'Backoff multiplier', width: 170, sortable: false },
  { field: 'timeoutMinutes', headerName: 'Timeout (min)', width: 140, sortable: false },
]
